<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card light id="rptcard">
        <v-card-text
          style="text-align: center"
          v-if="!loading && reportCards.length == 0"
        >
          <h3>Class has no students.</h3>
        </v-card-text>
        <v-card-text style="text-align: center" v-if="loading">
          <v-progress-circular
            :indeterminate="true"
            :rotate="0"
            :size="68"
            :value="''"
            :width="3"
            color="light-blue"
            >{{ "loading..." }}</v-progress-circular
          >
        </v-card-text>
        <v-card-text
          v-for="(rpt, idx) in reportCards"
          :key="idx"
          style="page-break-after: always"
          v-if="!loading && reportCards"
        >
          <v-layout row wrap>
            <v-flex xs12 style="text-align: center">
              <h2 style="font-weight: bold">{{ $t("school_name") }}</h2>
              <h4 style="font-style: italic">
                {{
                  "(Motto: " +
                  settings.school.motto +
                  ")" /*$t("school_motto")*/
                }}
              </h4>
              <p>TERMINAL REPORT</p>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card flat>
                    <v-card-text>
                      <v-layout row>
                        <v-flex xs6>
                          <p>
                            <span style="font-weight: bold">PUPIL'S NAME:</span>
                            {{ rpt.name }}
                          </p>
                        </v-flex>
                        <v-flex xs4>
                          <p>
                            <span style="font-weight: bold">NO. ROLL:</span>
                            {{ rpt.rollno }}
                          </p>
                        </v-flex>
                        <v-flex xs2>
                          <p>
                            <span style="font-weight: bold">POSITION:</span>
                            {{ print_std_overall_position(rpt.position) }}
                          </p>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs6>
                          <p>
                            <span style="font-weight: bold">CLASS/FORM:</span>
                            {{ rpt.class }}
                          </p>
                        </v-flex>
                        <v-flex xs4>
                          <p>
                            <span style="font-weight: bold">TERM:</span>
                            {{ head_data.term }}
                          </p>
                        </v-flex>
                        <v-flex xs2>
                          <p>
                            <span style="font-weight: bold">YEAR:</span>
                            {{ head_data.year }}
                          </p>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs6>
                          <p>
                            <span style="font-weight: bold">DATE:</span>
                            {{ new Date().toISOString().substr(0, 10) }}
                          </p>
                        </v-flex>
                        <v-flex xs6>
                          <p>
                            <span style="font-weight: bold"
                              >NEXT TERM BEGINS:</span
                            >
                            {{ ntbrc }}
                          </p>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <v-card flat>
                    <v-divider></v-divider>
                    <v-card-text>
                      <!-- debits and credits row -->
                      <v-layout row wrap>
                        <!-- debits table -->

                        <v-data-table
                          :headers="rpt_headers"
                          :items="rpt.subjectScores ? rpt.subjectScores : []"
                          class="elevation-0"
                          :hide-actions="true"
                        >
                          <template v-slot:items="props">
                            <td class="text-xs-center">
                              {{ props.item.name }}
                            </td>
                            <td class="text-xs-center">
                              {{ props.item.cs }}
                            </td>
                            <td class="text-xs-center">
                              {{ props.item.es }}
                            </td>
                            <td class="text-xs-center">
                              {{ props.item.ts }}
                            </td>
                            <td class="text-xs-center">
                              {{ print_cs_avg(props.item.sid) }}
                            </td>
                            <td class="text-xs-center">
                              {{ props.item.grd }}
                            </td>
                            <td class="text-xs-center">
                              {{ props.item.rmk }}
                            </td>
                          </template>
                        </v-data-table>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <!-- bill summary row -->
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card flat>
                        <v-card-text>
                          <v-layout row>
                            <v-flex xs4>
                              <p>
                                <span style="font-weight: bold"
                                  >ATTENDANCE:</span
                                >..............
                              </p>
                            </v-flex>
                            <v-flex xs4>
                              <p>
                                <span style="font-weight: bold">OUT OF:</span>
                                {{ head_data.work_days }}
                              </p>
                            </v-flex>
                            <v-flex xs4>
                              <p>
                                <span style="font-weight: bold"
                                  >PROMOTED TO:</span
                                >
                                ..............
                              </p>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs12>
                              <p>
                                <span style="font-weight: bold">CONDUCT:</span>
                                ..............................................
                              </p>
                              <p>
                                <span style="font-weight: bold">ATTITUDE:</span>
                                .............................................
                              </p>
                              <p>
                                <span style="font-weight: bold">INTEREST:</span>
                                .............................................
                              </p>
                              <p>
                                <span style="font-weight: bold"
                                  >CLASS TEACHERS REMARKS:</span
                                >
                                ..............
                              </p>
                              <p>
                                <span style="font-weight: bold"
                                  >HEADTEACHER'S/HEAD MASTER'S REMARKS:</span
                                >
                                ..............
                              </p>
                            </v-flex>
                          </v-layout>

                          <v-layout row>
                            <v-flex xs6>
                              <p>
                                <span style="font-weight: bold"
                                  >SIGNATURE:</span
                                >
                                ..............
                              </p>
                            </v-flex>
                            <v-flex xs6>
                              <p>
                                <span style="font-weight: bold">DATE:</span>
                                ..............
                              </p>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs6>
                              <p>
                                <span style="font-weight: bold"
                                  >PARENT/GUARDIAN SIGNATURE:</span
                                >
                                ..............
                              </p>
                            </v-flex>
                            <v-flex xs6>
                              <p>
                                <span style="font-weight: bold">DATE:</span>
                                ..............
                              </p>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "report-cards",
  props: {
    selected_class: {
      type: Object,
    },
    ntbrc: {
      type: String,
    },
  },
  data() {
    return {
      head_data: {
        term: "",
        year: "",
        work_days: "",
      },
      class_score_perc: "",
      exam_score_perc: "",
      sotl_coll: [], //collection of student overall totals
      subj_stats: [], //this will be used to group all the marks of students together for all subjects in one big array
      reportCards: [],
    };
  },
  created() {
    this.$store.dispatch("settings/getAll");
  },
  methods: {
    get_grade_and_remarks(score) {
      let c = parseFloat(score);
      if (c >= 80 && c <= 100) {
        return {
          grade: "A1",
          rmk: "Excellent",
        };
      } else if (c >= 70 && c <= 79.99) {
        return {
          grade: "B2",
          rmk: "Very Good ",
        };
      } else if (c >= 65 && c <= 69.99) {
        return {
          grade: "B3",
          rmk: "Good",
        };
      } else if (c >= 60 && c <= 64.99) {
        return {
          grade: "C4",
          rmk: "Credit",
        };
      } else if (c >= 55 && c <= 59.99) {
        return {
          grade: "C5",
          rmk: "Credit",
        };
      } else if (c >= 50 && c <= 54.99) {
        return {
          grade: "C6",
          rmk: "Credit",
        };
      } else if (c >= 45 && c <= 49.99) {
        return {
          grade: "D7",
          rmk: "Pass",
        };
      } else if (c >= 40 && c <= 44.99) {
        return {
          grade: "E8",
          rmk: "Pass",
        };
      } else {
        return {
          grade: "F",
          rmk: "Below Average",
        };
      }
    },
    sss(subj_id, s_marks) {
      //sss stands for selected subject score
      //extracts student's subject score from student marks received from db, params {subject_id=>the subject mark we are looking for,s_marks=>student's collection of marks for the term}
      let ss = s_marks ? s_marks.filter((x) => x.subject_id == subj_id) : ""; //ss= subject scores (both class and exam score)
      if (ss[0]) {
        let rmkgrd = this.get_grade_and_remarks(ss[0].total_score);
        return {
          sid: subj_id,
          cs: parseFloat(ss[0].class_score),
          es: parseFloat(ss[0].exam_score),
          ts: parseFloat(ss[0].total_score),
          grd: rmkgrd.grade,
          rmk: rmkgrd.rmk,
        };
      } else {
        return { cs: "", es: "", ts: "", rm: "" };
      }
    },
    cs_avg(subject_id) {
      //class subject average

      let subject_sum = this.reportCards
        .map((x) => x.subjectScores)
        .flat(1)
        .filter((s) => s.sid == subject_id)
        .reduce((sum, val) => {
          return sum + parseFloat(val.ts);
        }, 0);
      let sub_avg = subject_sum / this.reportCards.length;

      return sub_avg ? parseFloat(sub_avg).toFixed(2) : "";
    },
    print_cs_avg(sid) {
      //for printing calculated subject average from sub_avgs on report for a particular subject using the subject id for selection
      let subj = this.subj_stats.find((x) => x.sid == sid);
      return subj ? subj.avg : "";
    },
    print_std_subj_position(subject) {
      //prints position of student for a chosen subject whiles generating the report
      let foundSubj = this.subj_stats.find((x) => x.sid == subject.sid);
      if (foundSubj) {
        let ps = foundSubj.ranked_scores.findIndex(
          (item) => item.score == subject.ts
        );
        let v = parseInt(ps) + 1;
        return v + "" + this.nth(v);
      }
    },
    print_std_overall_position(idx) {
      // let s = std.s_marks.reduce((sum, val) => {
      //   return sum + parseFloat(val.total_score);
      // }, 0);
      // let pos = this.reportCards.findIndex(std);

      // let v = parseInt(idx) + 1;
      return idx + "" + this.nth(idx);
    },

    //helper functions
    nth(n) {
      return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
    },
    arrayReverseObj(obj) {
      let newArray = [];
      Object.keys(obj)
        .sort()
        .reverse()
        .forEach((key) => {
          //console.log(key);
          newArray.push({
            score: key,
            //id: obj[key].id
          });
        });
      return newArray;
    },
    // rank_std_in_sub(subject_id) {
    //   //this will rank student scores for the subject from highest to lowest

    //   let sub_std_scores = this.trpts
    //     .map((x) => x.s_marks)
    //     .flat(1)
    //     .filter((s) => s.subject_id == subject_id);
    //   const grouped_sub_scores = sub_std_scores.reduce(
    //     (groups, subj) => ({
    //       //grouped subject scores by total_score to find position for student in the subject
    //       ...groups,
    //       [subj.total_score]: [...(groups[subj.total_score] || []), subj],
    //     }),
    //     {}
    //   );
    //   return grouped_sub_scores ? this.arrayReverseObj(grouped_sub_scores) : [];
    // },
    std_all_subj_score_ttls() {
      let std_overall_totals = this.trpts.map((s) => {
        let overall_total = s.s_marks.reduce((sum, val) => {
          return sum + parseFloat(val.total_score);
        }, 0);
        return {
          std_id: s.id,
          sottl: parseFloat(overall_total).toFixed(2), //student overall total for all subjects for the term
        };
      });

      const grouped_sotl_coll = std_overall_totals.reduce(
        (groups, ot) => ({
          //grouped subject scores by total_score to find position for student in the subject
          ...groups,
          [ot.sottl]: [...(groups[ot.sottl] || []), ot],
        }),
        {}
      );

      this.sotl_coll = grouped_sotl_coll
        ? this.arrayReverseObj(grouped_sotl_coll)
        : [];
    },
  },
  computed: {
    ...mapGetters({
      trpts: "docs/TRPTS",
      errors: "docs/DOC_ERROR",
      loading: "docs/DOC_LOADING",

      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      sloading: "settings/SETTING_LOADING",
    }),
    csh() {
      return this.settings.school && this.settings.school.class_score
        ? "CLASS SCORE(" + parseFloat(this.settings.school.class_score) + "%)"
        : "";
    },
    esh() {
      return this.settings.school && this.settings.school.exam_score
        ? "EXAM SCORE(" + parseFloat(this.settings.school.exam_score) + "%)"
        : "";
    },
    rpt_headers() {
      return [
        {
          text: "SUBJECT",
          sortable: false,
          value: "name",
          width: "10%",
        },
        {
          text: this.csh,
          align: "center",
          sortable: false,
          value: "class_score",
          width: "10%",
        },
        {
          text: this.esh,
          align: "center",
          sortable: false,
          value: "exam_score",
          width: "10%",
        },
        {
          text: "TOTAL (100%)",
          align: "center",
          sortable: false,
          value: "total",
          width: "10%",
        },
        {
          text: "CLASS AVERAGE",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "GRADE",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "REMARKS",
          align: "center",
          sortable: false,
          value: "name",
        },
      ];
    },
  },
  watch: {
    selected_class(val) {
      if (val) {
        this.$store.dispatch("docs/getTRpts", { class_id: val.id });
      }
    },
    settings(val) {
      if (val) {
        this.head_data.term = val.ayt.term.name;
        this.head_data.year = val.ayt.acyear.year;
        this.head_data.work_days = val.ayt.term.work_days;
      }
    },
    async trpts(val) {
      if (val) {
        //building report card for all students
        let c = await val.map((s) => {
          //s = student
          var stdsubjscores = this.selected_class.subjects.map((subj) => {
            //subj means subject
            let sc = this.sss(subj.id, s.s_marks);
            sc.name = subj.name;
            return sc;
          });

          return {
            name: s.s_bio.name,
            rollno: s.rollno,
            class: s.s_class.name,
            subjectScores: stdsubjscores,
            overall_score: stdsubjscores.reduce((sum, val) => {
              return sum + parseFloat(val.ts ? val.ts : 0);
            }, 0), //sum of all subject scores to determine position
          };
        });

        var index = 0,
          prevValue = 0;
        this.reportCards = _.sortBy(c, ["overall_score"]).reverse();
        this.reportCards.forEach((rpt, i) => {
          if (prevValue != rpt.overall_score) index++;
          prevValue = rpt.overall_score;
          this.reportCards[i].position = index;
        });

        if (this.selected_class.subjects) {
          this.subj_stats = this.selected_class.subjects.map((x) => {
            //stats for selected subjected
            return {
              sid: x.id,
              avg: this.cs_avg(x.id),
              //ranked_scores: this.rank_std_in_sub(x.id),
            };
          });

          //console.log("ijijojojojo", this.subj_stats);
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/student/reportCard.vue